import { VisualsDistributionCategoryEnum } from 'visuals/interfaces/visuals-distribution/visual-distribution-categories.enum';
import { DistributionCategory, RoomDistributionCategory } from '../enums/distribution-types.enum';
import { IUploadPreviewSettings, IUploadPreviewSettingsXLSX } from '../interfaces/upload-preview-setting.interface';

export enum EnvironmentNamesEnum {
    local = 'local',
    featureDev = 'featureDev',
    dev = 'dev',
    qa = 'qa',
    uat = 'uat',
    prod = 'prod',
}

export const PAGE_SIZES_LIST = [20, 50, 100];
export const MAX_IMAGE_SIZE = 4;
export const MAX_IMAGE_SIZE_UNITS = 'MB';
export type FileType = 'image' | 'html';
export const TOKEN_KEY = 'token';
export const ICE_DASHBOARD_TOKEN_KEY = 'iceDashboardToken';
export const IDENTITY_TOKEN_KEY = 'identityToken';
export const PASSWORD_CHANGE_TOKEN = 'passwordChangeToken';
export const PASSWORD_CHANGE_EMAIL = 'email';
export const IS_SHIJI_USER_KEY = 'isShijiUser';
export const LETTERS_DIGITS_SPACES_VALIDATOR = /^[a-zA-Z][a-zA-Z0-9 ]*$/;
export const LETTERS_DIGITS_SPACES_DASHES_VALIDATOR = /^[a-zA-Z][a-zA-Z0-9 \-]*$/;
export const ID_ZERO = '00000000-0000-0000-0000-000000000000';
export const ZERO_DATE = '0001-01-01T00:00:00';

export const enum UserType {
    SUPPLIER_USER = 'SUPPLIER_USER',
    SHIJI_USER = 'SHIJI_USER',
    UNKNOWN = 'UNKNOWN',
}

export const IMAGE_SUPPORTED_TYPES = '.JPG, .PNG, .JPEG, .TIFF, .BMP';

export const LOGO_SETTINGS: IUploadPreviewSettings = {
    accept: 'image/jpg, image/png, image/jpeg, image/tiff, image/bmp',
    extensions: IMAGE_SUPPORTED_TYPES,
    fileType: 'image',
    label: 'logo',
};

export const TERMS_AND_CONDITIONS_SETTINGS: IUploadPreviewSettings = {
    accept: '.html',
    extensions: '.HTML',
    fileType: 'html',
    label: 'T&C',
};

export const BATCH_OPERATIONS_SETTINGS: IUploadPreviewSettingsXLSX = {
    accept: '.xlsx',
    extensions: '.xlsx',
    fileType: 'xlsx',
    label: '',
};

// When changing this be sure to change both the template checkbox order and the form group order
export const PERMISSIONS_HIERARCHY = ['read', 'edit', 'invite', 'create', 'delete', 'publish', 'allow'];

export const SAVE_OPTIONS = {
    saveOnly: 'saveOnly',
    returnToEditor: 'returnToEditor',
    submitForApproval: 'submitForApproval',
    submitForPublishing: 'submitForPublishing',
    discard: 'discard',
};

export const DISTRIBUTION_WITH_CHANNELS: DistributionCategory[] = [
    DistributionCategory.INCLUDE_ONLY_SELECTED,
    DistributionCategory.INCLUDE_ALL_EXCEPT_SELECTED,
];

export const VISUAL_DISTRIBUTION_WITH_CHANNELS: VisualsDistributionCategoryEnum[] = [
    VisualsDistributionCategoryEnum.INCLUDE_ONLY_SELECTED,
    VisualsDistributionCategoryEnum.INCLUDE_ALL_EXCEPT_SELECTED,
];
export const DISTRIBUTION_CATEGORIES_LABELS: string[] = Object.keys(DistributionCategory);

export const ROOM_DISTRIBUTION_WITH_CHANNELS: RoomDistributionCategory[] = [
    RoomDistributionCategory.INCLUDE_ONLY_SELECTED,
    RoomDistributionCategory.INCLUDE_ALL_EXCEPT_SELECTED,
];
export const ROOM_DISTRIBUTION_CATEGORIES_LABELS: string[] = Object.keys(RoomDistributionCategory);
export const VISUAL_DISTRIBUTION_CATEGORIES_LABELS: string[] = Object.keys(VisualsDistributionCategoryEnum);

//DATEPICKER

const style = getComputedStyle(document.documentElement);
export const DATEPICKER_STYLES = `
            .calendar > .days-grid > .day {
                cursor: pointer;

                &:hover {
                    border-color: ${style.getPropertyValue('--color-primary-900')};
                    color: ${style.getPropertyValue('--color-primary-900')};
                    font-weight: bold;
                }

                &.selected {
                    background-color: ${style.getPropertyValue('--color-primary-700')};

                    &:hover:not(.today) {
                        color: white;
                        border-color: ${style.getPropertyValue('--color-primary-700')};
                        font-weight: normal;
                    }

                    &.today {
                        color: white;
                    }
                }

                &.today {
                    color: ${style.getPropertyValue('--color-primary-900')};
                    font-weight: bold;
                }
            }

            .container:not(.show) {
                display: none;
            }
`;

export const BLOCKED_NUMBER_INPUT_KEYS = ['-', 'e', '.', '+', 'E'];
export const MIN_TIME_VALUE_IN_MINUTES = 1;
export const MAX_TIME_VALUE_IN_MINUTES = 300;

export const PASSWORD_MIN_LENGTH = 8;

export const OVERRIDE_TOGGLE_KEY = 'overrideFeatureFlags';
export const OVERRIDE_LIST_KEY = 'overrideFeatureFlagsList';
